import { AthosFetcher } from '../classes/athos-fetcher'
import { generateAthosProvider } from './provider'
import { normaliseResults } from '../helpers/normalisers'
import { isAthosInstockOnly } from '../athos-utils'

export class AthosAutocomplete extends AthosFetcher {
  generateURL() {
    return super.generateURL('/autocomplete')
  }

  updateParams(options = {}) {
    const { query, originalQuery, resultsPerPage } = options

    this.params.setDomainParam()
    this.params.set('resultsFormat', 'native')
    this.params.set('redirectResponse', 'full')

    if (query) this.params.set('q', query)
    else this.params.delete('q')
    if (isAthosInstockOnly()) this.params.set('bgfilter.ss_available', 1)
    if (resultsPerPage) this.params.set('resultsPerPage', resultsPerPage)
    if (originalQuery) this.params.set('oq', originalQuery)

    super.updateParams()
  }
}

export const AthosAutocompleteProvider = generateAthosProvider(AthosAutocomplete, (results) => {
  return {
    ...results,
    results: normaliseResults(results?.results)
  }
})
